import { render, staticRenderFns } from "./ContractListv2.vue?vue&type=template&id=3cc71ad3&"
import script from "./ContractListv2.vue?vue&type=script&lang=js&"
export * from "./ContractListv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports